<template>
  <div class="sf-layout">
    <!-- ── Header ─────────────────────────────────────── -->
    <header class="sf-header" :class="{ 'sf-header--scrolled': scrolled }">
      <div class="sf-header__inner">
        <!-- Logo -->
        <router-link to="/" class="sf-header__logo">
          <img src="/logo.png" alt="Stag Fondation" loading="lazy" />
        </router-link>

        <!-- Desktop Nav -->
        <nav class="sf-header__nav" aria-label="Navigation principale">
          <router-link
            v-for="item in navItems"
            :key="item.href"
            :to="item.href"
            class="sf-header__nav-link"
            active-class="sf-header__nav-link--active"
          >{{ item.label }}</router-link>
        </nav>

        <!-- CTA -->
        <div class="sf-header__cta">
          <router-link to="/faire-un-don">
            <button class="sf-btn sf-btn--terra sf-btn--sm">
              <Heart class="sf-btn__icon" />
              Faire un don
            </button>
          </router-link>
        </div>

        <!-- Mobile toggle -->
        <button
          class="sf-header__burger"
          @click="mobileOpen = !mobileOpen"
          :aria-expanded="mobileOpen"
          aria-label="Menu"
        >
          <X v-if="mobileOpen" />
          <Menu v-else />
        </button>
      </div>

      <!-- Mobile menu -->
      <div class="sf-header__mobile" :class="{ 'sf-header__mobile--open': mobileOpen }">
        <nav class="sf-header__mobile-nav">
          <router-link
            v-for="item in navItems"
            :key="item.href"
            :to="item.href"
            class="sf-header__mobile-link"
            @click="mobileOpen = false"
          >{{ item.label }}</router-link>
        </nav>
        <router-link to="/faire-un-don" @click="mobileOpen = false">
          <button class="sf-btn sf-btn--terra sf-btn--full" style="margin-top:1rem">
            Faire un don
          </button>
        </router-link>
      </div>
    </header>

    <!-- ── Page content ───────────────────────────────── -->
    <router-view name="two"></router-view>

    <!-- ── Footer ─────────────────────────────────────── -->
    <footer class="sf-footer">
      <div class="sf-footer__main">
        <!-- Brand -->
        <div class="sf-footer__col sf-footer__col--brand">
          <img src="/logo.png" alt="Stag Fondation" class="sf-footer__logo bg-white" loading="lazy" />
          <p class="sf-footer__tagline">
            Une ONG dédiée à l'impact social et à la formation technologique.
            Nous créons des ponts entre associations et communautés.
          </p>
          <div class="sf-socials" style="margin-top:1.25rem">
            <a href="https://www.facebook.com/share/1Di2uv7XZn/?mibextid=wwXIfr" target="_blank" rel="noopener" class="sf-social-btn"><Facebook /></a>
            <a href="#" class="sf-social-btn"><Twitter /></a>
            <a href="#" class="sf-social-btn"><Linkedin /></a>
            <a href="https://www.instagram.com/tchoun.dja" target="_blank" rel="noopener" class="sf-social-btn"><Instagram /></a>
          </div>
        </div>

        <!-- Quick links -->
        <div class="sf-footer__col">
          <h4 class="sf-footer__col-title">Liens rapides</h4>
          <ul class="sf-footer__links">
            <li><router-link to="/">Accueil</router-link></li>
            <li><router-link to="/a-propos">À propos</router-link></li>
            <li><router-link to="/projets">Projets</router-link></li>
            <li><router-link to="/formations">Formations</router-link></li>
            <li><router-link to="/associations">Associations</router-link></li>
            <li><router-link to="/actualites">Actualités</router-link></li>
          </ul>
        </div>

        <!-- Engagements -->
        <div class="sf-footer__col">
          <h4 class="sf-footer__col-title">S'engager</h4>
          <ul class="sf-footer__links">
            <li><router-link to="/faire-un-don">Faire un don</router-link></li>
            <li><router-link to="/associations">Devenir partenaire</router-link></li>
            <li><router-link to="/formations">S'inscrire à une formation</router-link></li>
            <li><router-link to="/team">Notre équipe</router-link></li>
            <li><router-link to="/contact">Nous rejoindre</router-link></li>
          </ul>
        </div>

        <!-- Contact -->
        <div class="sf-footer__col">
          <h4 class="sf-footer__col-title">Contact</h4>
          <ul class="sf-footer__contact">
            <li>
              <MapPin />
              <span>Oyack Source, Douala, Cameroun</span>
            </li>
            <li>
              <Mail />
              <a href="mailto:contact@stagfondation.org">contact@stagfondation.org</a>
            </li>
            <li>
              <Phone />
              <a href="tel:+237651363798">+237651363798</a>
               <a href="tel:+15145890214">+15145890214</a>
            </li>
          </ul>
        </div>
      </div>

      <!-- Bottom bar -->
      <div class="sf-footer__bottom">
        <p>© {{ currentYear }} Stag Fondation. Tous droits réservés.</p>
        <!-- <div class="sf-footer__legal">
          <router-link to="/privacy">Politique de confidentialité</router-link>
          <router-link to="/terms">Conditions d'utilisation</router-link>
        </div> -->
      </div>
    </footer>
  </div>
</template>

<script>
import { Menu, X, Heart, Facebook, Twitter, Linkedin, Instagram, Mail, Phone, MapPin } from 'lucide-vue-next'

export default {
  name: 'AppLayout',
  components: { Menu, X, Heart, Facebook, Twitter, Linkedin, Instagram, Mail, Phone, MapPin },
  data() {
    return {
      mobileOpen: false,
      scrolled: false,
      currentYear: new Date().getFullYear(),
      navItems: [
        { label: 'Accueil',      href: '/' },
        { label: 'Actualités',   href: '/actualites' },
        { label: 'Associations', href: '/associations' },
        { label: 'Formations',   href: '/formations' },
        { label: 'Projets',      href: '/projets' },
        {label: 'Événements',    href: '/evenements' },
        { label: 'À propos',     href: '/a-propos' },
        { label: 'Équipe',       href: '/team' },
        { label: 'Contact',      href: '/contact' },
      ]
    }
  },
  mounted() {
    this._onScroll = () => { this.scrolled = window.scrollY > 40 }
    window.addEventListener('scroll', this._onScroll, { passive: true })
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this._onScroll)
  }
}
</script>

<style>
@import '../acceuil/sf-design.css';
</style>

<style scoped>
/* ── Root ────────────────────────────────────────────────── */
.sf-layout { display:flex; flex-direction:column; min-height:100vh; background:var(--cream); }

/* ── Header ──────────────────────────────────────────────── */
.sf-header {
  position:sticky; top:0; z-index:100;
  background:rgba(245,239,224,.85);
  backdrop-filter:blur(12px);
  border-bottom:1px solid transparent;
  transition:border-color .3s ease, box-shadow .3s ease;
  font-family:var(--fb);
}
.sf-header--scrolled {
  border-bottom-color:var(--ink-20);
  box-shadow:0 2px 16px rgba(26,26,18,.07);
}
.sf-header__inner {
  max-width:1280px; margin:0 auto;
  padding:0 1.5rem;
  height:68px;
  display:flex; align-items:center; justify-content:space-between; gap:1rem;
}
.sf-header__logo img { height:52px; object-fit:contain; }

.sf-header__nav { display:none; align-items:center; gap:.25rem; }
@media (min-width:1024px) { .sf-header__nav { display:flex; } }
.sf-header__nav-link {
  padding:.4rem .75rem; border-radius:4px;
  font-size:.84rem; font-weight:500; color:var(--ink);
  text-decoration:none;
  transition:color .2s ease, background .2s ease;
}
.sf-header__nav-link:hover { color:var(--terra); background:rgba(200,90,42,.07); }
.sf-header__nav-link--active { color:var(--terra); }

.sf-header__cta { display:none; }
@media (min-width:1024px) { .sf-header__cta { display:flex; } }

.sf-header__burger {
  display:flex; align-items:center; justify-content:center;
  width:40px; height:40px; border:none; border-radius:4px;
  background:transparent; cursor:pointer; color:var(--ink);
  transition:background .2s ease;
}
.sf-header__burger:hover { background:var(--cream-d); }
.sf-header__burger :deep(svg) { width:22px; height:22px; }
@media (min-width:1024px) { .sf-header__burger { display:none; } }

.sf-header__mobile {
  max-height:0; overflow:hidden;
  transition:max-height .35s cubic-bezier(.25,.46,.45,.94);
  background:var(--cream);
  border-top:1px solid transparent;
}
.sf-header__mobile--open {
  max-height:500px;
  border-top-color:var(--ink-20);
  padding:.75rem 1.5rem 1.25rem;
}
.sf-header__mobile-nav { display:flex; flex-direction:column; gap:.25rem; }
.sf-header__mobile-link {
  padding:.65rem .75rem; border-radius:4px;
  font-size:.9rem; font-weight:500; color:var(--ink);
  text-decoration:none; transition:color .2s ease, background .2s ease;
}
.sf-header__mobile-link:hover { color:var(--terra); background:rgba(200,90,42,.07); }

/* ── Footer ──────────────────────────────────────────────── */
.sf-footer { background:var(--forest); font-family:var(--fb); margin-top:auto; }
.sf-footer__main {
  max-width:1200px; margin:0 auto;
  padding:4rem 2rem 3rem;
  display:grid;
  grid-template-columns:2fr 1fr 1fr 1.4fr;
  gap:3rem;
}
@media (max-width:900px) { .sf-footer__main { grid-template-columns:1fr 1fr; gap:2rem; } }
@media (max-width:540px) { .sf-footer__main { grid-template-columns:1fr; } }

.sf-footer__logo { height:56px; object-fit:cover; margin-bottom:1rem; }
.sf-footer__tagline { font-size:.84rem; color:rgba(245,239,224,.6); line-height:1.65; }

.sf-footer__col-title {
  font-size:.72rem; letter-spacing:.16em; text-transform:uppercase;
  color:var(--amber); font-weight:500; margin-bottom:1.25rem;
}
.sf-footer__links { list-style:none; padding:0; margin:0; display:flex; flex-direction:column; gap:.5rem; }
.sf-footer__links a {
  font-size:.85rem; color:rgba(245,239,224,.55); text-decoration:none;
  transition:color .2s ease;
}
.sf-footer__links a:hover { color:var(--cream); }

.sf-footer__contact { list-style:none; padding:0; margin:0; display:flex; flex-direction:column; gap:.75rem; }
.sf-footer__contact li { display:flex; align-items:flex-start; gap:.6rem; font-size:.84rem; color:rgba(245,239,224,.55); }
.sf-footer__contact li :deep(svg) { width:16px; height:16px; color:var(--sage); flex-shrink:0; margin-top:2px; }
.sf-footer__contact a { color:inherit; text-decoration:none; }
.sf-footer__contact a:hover { color:var(--cream); }

.sf-footer__bottom {
  max-width:1200px; margin:0 auto;
  padding:1.5rem 2rem;
  border-top:1px solid rgba(255,255,255,.08);
  display:flex; align-items:center; justify-content:space-between;
  flex-wrap:wrap; gap:.75rem;
}
.sf-footer__bottom p { font-size:.8rem; color:rgba(245,239,224,.4); }
.sf-footer__legal { display:flex; gap:1.5rem; }
.sf-footer__legal a { font-size:.8rem; color:rgba(245,239,224,.4); text-decoration:none; transition:color .2s ease; }
.sf-footer__legal a:hover { color:rgba(245,239,224,.7); }
</style>
